// src/store/authStore.ts
import { create } from 'zustand';
import { User } from '@/types';
import { api } from '@/lib/api/client';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  initializeAuth: () => Promise<void>;
  login: (phoneNumber: string, password: string) => Promise<boolean>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,

  initializeAuth: async () => {
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) return;

    try {
      const data = await api.get<{ user: User }>('/auth/verify');
      set({ user: data.user });
    } catch (error) {
      console.error('Auth initialization error:', error);
      localStorage.removeItem('sessionToken');
    }
  },

  login: async (phoneNumber: string, password: string) => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.post<{ user: User; sessionId: string }>('/auth/login', {
        phoneNumber,
        password
      });

      set({ user: data.user });
      localStorage.setItem('sessionToken', data.sessionId);
      return true;
    } catch (error) {
      set({ error: error instanceof Error ? error.message : 'فشل تسجيل الدخول' });
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('sessionToken');
      set({ user: null });
    }
  }
}));
